import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import moment from "moment/moment";
import ResolveFareIssueDialog from "../ResolveFareIssueDialog";
import { makeStyles } from "@material-ui/core/styles";
import { getReasonOfFareIssue } from "../../../../utils/FareIssueTextDisplay";

const useStyles = makeStyles((theme) => ({
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gridTemplateAreas: `"reportData reason userComment userComment userComment"`,
    gap: 12,
    [theme.breakpoints.down(800)]: {
      gridTemplateColumns: "1fr 1fr",
      gridTemplateAreas: `
        "reason reportData"
        "userComment userComment"
      `,
    },
    [theme.breakpoints.down(400)]: {
      gridTemplateColumns: "1fr",
      gridTemplateAreas: `
        "reason"
        "reportData"
        "userComment"
      `,
    },
  },
}));

const OpenFareIssue = ({
  details,
  authorized,
  submitting,
  handleResolveFareIssue,
}) => {
  const classes = useStyles();
  const [showResolveDialog, setShowResolveDialog] = React.useState(false);

  return (
    <div>
      <div className={classes.grid}>
        <div style={{ gridArea: "reportData" }}>
          {details.version !== "v1" && (
            <>
              <div>
                <Typography color="textSecondary">
                  Data zgłoszenia reklamacji
                </Typography>
                <Typography>
                  {moment(details.reportedAt)
                    .local()
                    .format("DD.MM.YYYY HH:mm")}
                </Typography>
              </div>
              <Divider />
            </>
          )}
          <Button
            disabled={!authorized}
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              setShowResolveDialog(true);
            }}
            style={{ marginTop: 5 }}
          >
            Zamknij reklamację
          </Button>
        </div>
        {details.version !== "v1" && (
          <div style={{ gridArea: "reason" }}>
            <Typography color="textSecondary">Powód reklamacji</Typography>
            <Typography>{getReasonOfFareIssue(details.reason)}</Typography>
          </div>
        )}
        {details.version !== "v1" && (
          <div style={{ gridArea: "userComment" }}>
            <Typography color="textSecondary">Komentarz użytkownika</Typography>
            <Typography>{details.mobileUserComments}</Typography>
          </div>
        )}
      </div>
      <ResolveFareIssueDialog
        open={showResolveDialog}
        onSave={handleResolveFareIssue}
        onCancel={() => {
          setShowResolveDialog(false);
        }}
        submitting={submitting}
      />
    </div>
  );
};

OpenFareIssue.propTypes = {
  details: PropTypes.object.isRequired,
  authorized: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  handleResolveFareIssue: PropTypes.func.isRequired,
};

export default OpenFareIssue;
